<template>
  <div class="auth-container">
    <div class="center">
      <router-link :to="{ name: 'top' }">
        <img class="logo" src="~@/assets/img/logo.png" />
      </router-link>
      <cat-icon v-if="writerType" class="cat-icon" :writerType="writerType" :clickable="false" />
    </div>
    <div class="auth-container__card">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import CatIcon from "@/components/atoms/CatIcon.vue";

export default Vue.extend({
  name: "AuthContainer",
  components: {
    CatIcon,
  },
  props: {
    // CatIcon の writerType 。未指定の場合は CatIcon を表示しない
    writerType: {
      type: String,
      default: "",
    },
  },
});
</script>

<style lang="scss" scoped>
$logo-width: 100px;

.logo {
  width: $logo-width;
}

.auth-container {
  padding: 16px;
  width: 380px;
  min-width: 300px;
  color: var(--color-text-normal);

  @include mq(sp) {
    padding: 20px 16px;
    width: 95%;
    min-width: 0;
  }

  .center {
    text-align: center;
    position: relative;
    margin-bottom: 12px;

    .cat-icon {
      position: absolute;
      top: -16px;
      left: 50%;
      transform: translateX(calc(#{$logo-width} / 2));
      width: 80px;
      height: 80px;
    }
  }

  &__card {
    background-color: var(--color-background-normal);
    border-radius: var(--radius-lg);
    padding: 16px;
    box-shadow: var(--shadow-lg);
    position: relative;
    z-index: 1;
  }
}
</style>
